import { render } from "./ApplicantCV.vue?vue&type=template&id=77b90746"
import script from "./ApplicantCV.vue?vue&type=script&lang=js"
export * from "./ApplicantCV.vue?vue&type=script&lang=js"

import "./ApplicantCV.vue?vue&type=style&index=0&id=77b90746&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__